<template>
    <b-modal
        ref="artifactPreviewModal"
        cancel-variant="outline-secondary"
        size="xl"
        :ok-title="$t('Component(Button):close')"
        scrollable
        ok-only
        centered
        :title="artifact ? artifact.filename : ''"
    >
        <Overlay :show="showOverlay">
            <object
                v-if="downloadUrl"
                :data="downloadUrl"
                :type="artifact ? artifact.mimeType : 'application/pdf'"
                width="100%"
                :height="height"
                @load="onLoaded"
            >
                unable to display document
            </object>
        </Overlay>
    </b-modal>
</template>

<script>
import {BModal} from 'bootstrap-vue'
import Overlay from '@core/components/common/Overlay'

export default {
    components: {
        BModal,
        Overlay,
    },
    props: {
        artifact: {
            type: Object,
            default: null,
        },
        downloadUrl: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showOverlay: true,
            height: this.calculateHeight(),
            resizeObserver: null,
        }
    },
    mounted() {
        this.resizeObserver = new ResizeObserver(this.onResize)
        this.resizeObserver.observe(document.body)
    },
    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect()
        }
    },
    methods: {
        show() {
            this.showOverlay = true
            this.$refs.artifactPreviewModal.show()
        },
        onLoaded() {
            this.showOverlay = false
        },
        onResize() {
            this.height = this.calculateHeight()
        },
        calculateHeight() {
            return `${document.body.offsetHeight - 200}px`
        },
    },
}
</script>
